import { encounterField } from './array-types';

/** A confirmed editor save must advance its raw rows before it projects lighting again. */
export async function refreshSavedEditorEncounter(encounterId: string): Promise<boolean> {
    const raw = document.getElementById('modify_encounter_creation_engine_bootstrap')?.textContent;
    if (!raw) return false;
    const seed = JSON.parse(raw) as {
        canManageCampaign?: boolean; source?: string; sceneReviewFixture?: unknown;
        surface?: { canRunTable?: boolean; queryOnly?: boolean };
    };
    const table = seed.surface?.canRunTable !== false
        && new URLSearchParams(location.search).get('ft3d_campaign_view') === '1';
    if (!seed.canManageCampaign || table || seed.surface?.queryOnly || seed.sceneReviewFixture
        || seed.source === 'query-review-fixture') return false;
    const id = encounterId.trim().toUpperCase();
    if (!id) throw new Error('Saved encounter identity is unavailable.');
    // Force the existing parent/standalone read bridge to bypass both caches. The bridge owns
    // compilation and installs a separate mutable copy in the frame, as it does on first load.
    const saved = await getEncounterArr(id, true, true);
    if (!saved || String(encounterField(saved, 'encounter_id') ?? '').trim().toUpperCase() !== id) {
        throw new Error('The saved encounter could not be refreshed.');
    }
    Object.assign(window, { ftModifyEncounterPageEncounterArr: saved });
    window.dispatchEvent(new CustomEvent('ft:encounter-state-received', {
        detail: { encounterId: id, encounterArr: saved, subType: 'editor_settings_saved' },
    }));
    return true;
}
